import { Checklist, EuroRounded } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from '@mui/icons-material/Save'
import SearchIcon from '@mui/icons-material/Search'
import {
	Box,
	Button,
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	FormLabel,
	MenuItem,
	TextField,
	IconButton, useMediaQuery, useTheme, Typography
} from '@mui/material'
import Grid from "@mui/material/Grid2";
import Tooltip from "@mui/material/Tooltip";
import { DatePicker, DateTimePicker, TimePicker } from "@mui/x-date-pickers-pro";
import axios from 'axios'
import dayjs from "dayjs";
import { ErrorMessage, FormikProvider } from 'formik'
import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import React, {useCallback, useMemo, useRef, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { NumericFormat } from 'react-number-format'
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import PageMenu from '../../../../components/custom/app/pageMenu/pageMenu'
import FileUpload from "../../../../components/custom/form/fileUpload/fileUpload";
import FormBoxTitle from '../../../../components/mui/app/formBoxTitle/formBoxTitle'
import PageContentWrapper from '../../../../components/mui/app/pageContentWrapper/pageContentWrapper'
import PageTitle from '../../../../components/mui/app/pageTitle/pageTitle'
import CustomAutocomplete from '../../../../components/mui/form/autocomplete/autocomplete'
import Confirmation from "../../../../components/mui/general/confirmation/confirmation";
import NavigateBackButton from "../../../../components/mui/general/navigateBackButton/navigateBackButton";
import { API, IssueStatus, PriorityPlanned, TimeUnits } from "../../../../helpers/constants";

import { handleAxiosErrors, logoutUnauthorizedUser } from "../../../../helpers/errorHandling";
import { issueIsClosed } from "../../../../helpers/helpers";
import {
	edit_issue_active,
	edit_issue_actual_end,
	edit_issue_actual_start,
	edit_issue_address,
	edit_issue_address_contact,
	edit_issue_assignee,
	edit_issue_billable,
	edit_issue_charge,
	edit_issue_customer,
	edit_issue_description,
	edit_issue_duration,
	edit_issue_estimated_cost,
	edit_issue_estimated_end,
	edit_issue_estimated_start,
	edit_issue_estimated_work,
	edit_issue_view_items,
	edit_issue_kind,
	edit_issue_owner,
	edit_issue_priority,
	edit_issue_project,
	edit_issue_proposed_work,
	edit_issue_serial_number,
	edit_issue_service,
	edit_issue_service_category,
	edit_issue_site,
	edit_issue_sla,
	edit_issue_status,
	edit_issue_submit_date,
	edit_issue_summary,
	edit_issue_team,
	edit_issue_technicians,
	edit_issue_type,
	issue_active,
	issue_actual_end,
	issue_actual_start,
	issue_address,
	issue_address_contact,
	issue_address_contact_info,
	issue_assignee,
	issue_billable,
	issue_charge,
	issue_customer,
	issue_customer_contact_info,
	issue_description,
	issue_duration,
	issue_estimated_cost,
	issue_estimated_end,
	issue_estimated_start,
	issue_estimated_work,
	issue_fm_info,
	issue_view_items,
	issue_kind,
	issue_owner,
	issue_priority,
	issue_project,
	issue_proposed_work,
	issue_serial_number,
	issue_service,
	issue_service_category,
	issue_site,
	issue_sla,
	issue_status,
	issue_submit_date,
	issue_summary,
	issue_team,
	issue_technicians,
	issue_type,
	issue_add_items,
	edit_issue_add_items,
	issue_delete_items,
	edit_issue_delete_items,
	edit_issue_edit_items,
	issue_edit_items,
	view_issue_auditing,
	issue_complete,
	issue_pending,
	issue_cancel,
	issue_inability,
	issue_view_erp_code,
	issue_edit_reference_code,
	issue_reference_code,
	edit_closed_issue,
	view_financial_info,
	edit_issue_actual_charge,
	issue_actual_charge,
	view_edit_financial_info,
	issue_targeted_end,
	edit_issue_targeted_end,
	edit_issue_targeted_start,
	issue_targeted_start,
	issue_so_order,
	edit_issue_actual_visit_date, issue_actual_visit_date, add_issue_checklist, view_checklists
} from "../../../../helpers/rights/rights";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import {
	formControlDefaults,
	numericFormatDefaults,
	textFieldDefaults,
	textFieldSelectDefaults,
} from '../../../../helpers/theme/defaultProps'
import useUserAction from "../../../../hooks/user/useUserAction";
import useUserData from "../../../../hooks/user/useUserData";
import { timeUnitsConversions } from '../../../../helpers/unitConversions'
import { ROUTE_PAGE_HOME } from "../../../../routers/routes";
import PermissionHOC from "../../../permission/components/permissionHOC/permissionHOC";
import { useHasPermission } from "../../../permission/hooks/useHasPermission";
import useIssueForm, { calculateDuration } from '../../hooks/useIssueForm'
import { ISSUES_FORM } from '../../locales/namespaces'
import { ROUTE_PAGE_ISSUE_CHECKLISTS, ROUTE_PAGE_ISSUES_INDEX } from "../../routes/routes";
import CustomerSO from "../customerSO/customerSO";
import FollowUpButton from "../followUpButton/followUpButton";
import IssueAuditingHistory from "../issueAuditingHistory/issueAuditingHistory";
import Assets from "./partials/assets";
import Items from "./partials/items";

const IssueForm = (props) => {
	const {
		IssueId,
		issue,
		staticData,
		Copy,
		onSuccess,
		assignedType,
		assignedTypeId,
		CustomerId,
		fromDashboard,
		issueDataManager
	} = props
	
	const theme = useTheme();
	const isBelowSm = useMediaQuery(theme.breakpoints.down('sm'));
	const { t } = useTranslation(ISSUES_FORM)
	const { userLogout } = useUserAction()
	const { dateFormat, timeFormat, token, isLoggedIn, thousandSeparator, decimalSeparator } = useUserData()
	const [loadingSearch, setLoadingSearch] = useState(false)
	const [customers, setCustomers] = useState(staticData.customers)
	const [users, setUsers] = useState(staticData.users)
	const [items, setItems] = useState(staticData.items)
	const [assets, setAssets] = useState(staticData.assets)
	const [contacts, setContacts] = useState(staticData.contacts)
	const [addresses, setAddresses] = useState(staticData.addresses)
	const [projects, setProjects] = useState(staticData.projects)
	const [sites, setSites] = useState(staticData.sites)
	const [slas, setSlas] = useState(staticData.slas)
	const [serviceItems, setServiceItems] = useState(staticData.serviceItems)
	const [userTeam, setUserTeam] = useState(staticData.userTeam)
	const [technicians, setTechnicians] = useState(staticData.technicians);
	const [suppliers, setSuppliers] = useState(staticData.suppliers);
	const [teams, setTeams] = useState(staticData.teams)
	const [teamUsers, setTeamUsers] = useState(staticData.teamUsers);
	const history = useHistory();
	
	const { formik, loadingSubmit } = useIssueForm({
		IssueId,
		issue,
		staticData,
		onSuccess,
		assignedType,
		assignedTypeId,
		CustomerId,
		Copy
	})
	
	const [confirmation, setConfirmation] = useState({
		open: false,
		status: null,
		prevStatus: null
	})
	const [openSOForm, setOpenSOForm] = useState(false)
	const closeSOForm = useCallback(() => (setOpenSOForm(false)), [])
	const suppliersLoadedRef = useRef(false)
	
	const editClosedIssue = useHasPermission([edit_closed_issue], { shouldView: true })
	const hasIssueTeamRight = useHasPermission([issue_team], { shouldView: true })
	const hasEditIssueTeamRight = useHasPermission([edit_issue_team], { shouldView: true })
	{/*TODO::Ενεργοποίησέ το πάλι όταν ζητήσουν να γίνει υποχρεωτική η συμπλήρωσή του! Είπαν στην πρώτη φάση να μην είναι. */
	}
	// const hasEditIssueActualStart = useHasPermission([edit_issue_actual_start], { shouldView: true, shouldEdit: true })
	const hasEditIssueEstimDue = useHasPermission([edit_issue_estimated_end], { shouldView: true, shouldEdit: true })
	const hasIssueEstimDue = useHasPermission([issue_estimated_end], { shouldView: true, shouldEdit: true })
	
	const onActionClick = useCallback((status) => {
		formik.validateForm()
		.then((response) => {
				if (Object.keys(response).length === 0) {
					const prevStatusId = formik.values.StatusId
					const statusId = status ? status : prevStatusId
					formik.setFieldValue('StatusId', statusId)
					if (status === IssueStatus.Akurothike) formik.setFieldValue('requireCancelComment', true)
					else formik.setFieldValue('requireCancelComment', false)
					setConfirmation({
						open: true,
						status: status,
						prevStatus: prevStatusId
					})
				} else {
					enqueueSnackbar(t('Please fill all required fields to continue!'), {
						variant: 'warning',
					})
				}
			}
		)
	}, [formik, t])
	
	const onCloseConfirmation = useCallback(() => {
		formik.setFieldValue('StatusId', confirmation.prevStatus)
		formik.setFieldValue('requireCancelComment', false)
		setConfirmation({
			open: false,
			status: null,
			prevStatus: null
		})
	}, [formik, confirmation.prevStatus])
	
	const calculateSLA = useCallback((parameters) => {
		const { custId, priorityId } = parameters
		if (custId && priorityId) {
			axios({
				method: 'post',
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				data: {
					CustId: custId,
					PriorityId: priorityId,
					SubmitDt: IssueId ? dayjs(formik.values.SubmitDt).format('YYYY-MM-DD HH:mm:ss') : dayjs().format('YYYY-MM-DD HH:mm:ss'),
				},
				url: `${API}/en/customers/slas/calculate`
			}).then((response) => {
				const { TargetedEndDt, TargetedStartDt, TargetedEndTm, TargetedStartTm } = response.data
				if (TargetedStartDt) formik.setFieldValue('TargetedStartDt', dayjs(TargetedStartDt))
				if (TargetedEndDt) formik.setFieldValue('TargetedEndDt', dayjs(TargetedEndDt))
				if (TargetedStartTm) formik.setFieldValue('TargetedStartTm', dayjs(TargetedStartTm, 'HH:mm:ss'))
				if (TargetedEndTm) formik.setFieldValue('TargetedEndTm', dayjs(TargetedEndTm, 'HH:mm:ss'))
			}).catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'error',
					autoHideDuration: 3000,
				})
				logoutUnauthorizedUser(error, isLoggedIn, userLogout)
			})
		}
	}, [t, isLoggedIn, userLogout, formik, IssueId])
	
	const onChangeAddressCustomerSiteService = useCallback((newValue, reason, name) => {
		let data
		switch (name) {
			case 'customers':
				data = {
					'CustId': newValue?.id,
					'ItemId': formik.values.ItemId?.id,
					'ReturnData': ["projects", "addresses", "contacts", "customers", "assets"]
				}
				break
			case 'addresses':
				data = {
					'AddressId': newValue?.id,
					'ItemId': formik.values.ItemId?.id,
					'CustId': formik.values.CustomerId?.id,
					'ReturnData': ["projects", "addresses", "contacts", "customers", "assets"]
				}
				break
			case 'sites':
				data = {
					'AddressId': newValue?.id,
					'CustId': formik.values.CustomerId?.id,
					'ItemId': formik.values.ItemId?.id,
					'ReturnData': ["projects", "contacts", "customers", "addresses", "assets"]
				}
				break
			default:
				data = {
					'CustId': formik.values.CustomerId?.id,
					'ReturnData': ["projects", "addresses", "contacts", "customers", "assets"]
				}
				break
		}
		
		if (reason === 'selectOption') {
			axios({
				method: 'post',
				data: data,
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				url: `${API}/en/issues/issueCustData`
			}).then((res) => {
				const data = res.data
				if (name === 'customers') {
					formik.setFieldValue('CustomerId', {
						...newValue,
						...(data.customers && data.customers.length === 1 && {
							MainContactName: data.customers[0].MainContactName,
							MainContactPhone: data.customers[0].MainContactPhone,
							MainContactEmail: data.customers[0].MainContactEmail,
						}: {})
					})
					// Διαχείριση διεύθυνσης και site όταν αλλάζει o Πελάτης
					if (data.addresses?.length === 0) {
						formik.setFieldValue('AddressId', '')
						formik.setFieldValue('Site', '')
					} else if (data.addresses?.length === 1) {
						const address = {
							...data.addresses[0],
							Description: data.addresses[0]?.MainAddress
						}
						formik.setFieldValue('AddressId', address)
						const site = {
							...data.addresses[0],
							Description: data.addresses[0]?.Site
						}
						formik.setFieldValue('Site', site)
					} else {
						formik.setFieldValue('AddressId', '')
						formik.setFieldValue('Site', '')
					}
					setAddresses(data.addresses?.map(address => ({
							...address,
							Description: address?.MainAddress
						}))
					)
					setSites(_.orderBy(data.addresses?.map(address => ({
							...address,
							Description: address?.Site
						})), ['Description'], ['asc'])
					)
					// Υπολογισμός SLA αν υπάρχουν για τη νέα επιλογή πελάτη
					calculateSLA({
						custId: newValue?.id,
						priorityId: formik.values.PriorityId
					})
				}
				if (name === 'sites') {
					formik.setFieldValue('Site', {
						...newValue,
						...(data.addresses && data.addresses.length === 1 ? {
							...data.addresses[0]
						} : {})
					})
					// Διαχείριση πελάτη όταν αλλάζει το site
					if (data.customers?.length === 1) {
						formik.setFieldValue('CustomerId', data.customers[0])
						// Υπολογισμός SLA για τον πελάτη του επιλεγμένου site
						calculateSLA({
							custId: data.customers[0]?.id,
							priorityId: formik.values.PriorityId
						})
					} else if (data.customers?.length === 0) {
						formik.setFieldValue('CustomerId', '')
					}
					setCustomers(data.customers)
					// Διαχείριση διεύθυνσης όταν αλλάζει το site
					if (data.addresses?.length === 0) {
						formik.setFieldValue('AddressId', '')
					} else if (data.addresses?.length === 1) {
						const address = {
							...data.addresses[0],
							Description: data.addresses[0]?.MainAddress
						}
						formik.setFieldValue('AddressId', address)
					} else {
						formik.setFieldValue('AddressId', '')
					}
					setAddresses(data.addresses?.map(address => ({
							...address,
							Description: address?.MainAddress
						}))
					)
					setSites(_.orderBy(data.addresses?.map(address => ({
							...address,
							Description: address?.Site
						})), ['Description'], ['asc'])
					)
				}
				if (name === 'addresses') {
					formik.setFieldValue('AddressId', {
						...newValue,
						...(data.addresses && data.addresses.length === 1 && {
							...data.addresses[0]
						}: {})
					})
					// Διαχείριση πελάτη όταν αλλάζει η διεύθυνση
					if (data.customers?.length === 1) {
						formik.setFieldValue('CustomerId', data.customers[0])
						// Υπολογισμός SLA για τον πελάτη της επιλεγμένη διεύθυνσης
						calculateSLA({
							custId: data.customers[0]?.id,
							priorityId: formik.values.PriorityId
						})
					} else if (data.customers?.length === 0) {
						formik.setFieldValue('CustomerId', '')
					}
					setCustomers(data.customers)
					// Διαχείριση site όταν αλλάζει η διεύθυνση
					if (data.addresses?.length === 0) {
						formik.setFieldValue('Site', '')
					} else if (data.addresses?.length === 1) {
						const site = {
							...data.addresses[0],
							Description: data.addresses[0]?.Site
						}
						formik.setFieldValue('Site', site)
					} else {
						formik.setFieldValue('Site', '')
					}
					setSites(_.orderBy(data.addresses?.map(address => ({
							...address,
							Description: address?.Site
						})), ['Description'], ['asc'])
					)
					setAddresses(data.addresses?.map(address => ({
							...address,
							Description: address?.MainAddress
						}))
					)
				}
				if (name === 'addresses' || name === 'customers' || name === 'sites') {
					// Διαχείριση Projects όταν αλλάζει διεύθυνση, site ή πελάτης
					if (data.projects?.length === 0) {
						formik.setFieldValue('PrjId', '')
					} else if (data.projects?.length === 1) {
						const project = {
							...data.projects[0],
							Description: data.projects[0]?.Description
						}
						formik.setFieldValue('PrjId', project)
					}
					setProjects(
						data.projects?.map(project => ({
							...project,
							Description: project?.Description
						}))
					)
					// Διαχείριση Επαφών, όταν αλλάζει διεύθυνση, site ή πελάτης
					if (data.contacts?.length === 0) {
						formik.setFieldValue('ContactId', '')
					} else if (data.contacts?.length === 1) {
						const contact = {
							...data.contacts[0],
							id: data.contacts[0]?.ContactId,
							Description: data.contacts[0]?.ContactName
						}
						formik.setFieldValue('ContactId', contact)
					}
					setContacts(
						_.orderBy(data.contacts?.map(item => ({
							...item,
							id: item?.ContactId,
							Description: item?.ContactName
						})), ['Description'], ['asc'])
					)
				}
				// Διαχείριση Assets, όταν αλλάζει διεύθυνση, site ή πελάτης ή υπηρεσία
				setAssets(res.data.assets ? res.data.assets : [])
				// Όταν αλλάζει η διεύθυνση ή η υπηρεσία επανέφερε τα assets γιατί αλλάζουν ανά διεύθυνση
				formik.setFieldValue('assets', [])
			}).catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'error',
					autoHideDuration: 3000,
				})
				logoutUnauthorizedUser(error, isLoggedIn, userLogout)
			})
		} else if (reason === 'clear') {
			if (name === 'customers') {
				formik.setFieldValue('CustomerId', '')
				setCustomers([...staticData.customers])
				formik.setFieldValue('Site', '')
				setSites([...staticData.sites])
				formik.setFieldValue('AddressId', '')
				setAddresses([...staticData.addresses])
				formik.setFieldValue('ContactId', '')
				setContacts([...staticData.contacts])
				formik.setFieldValue('ProjectId', '')
				setProjects([...staticData.projects])
			} else if (name === 'sites' || name === 'addresses') {
				formik.setFieldValue('Site', '')
				if (!formik.values.CustomerId) {
					setSites([...staticData.sites])
					setAddresses([...staticData.addresses])
				}
				formik.setFieldValue('AddressId', '')
				formik.setFieldValue('ContactId', '')
				setContacts([...staticData.contacts])
				formik.setFieldValue('ProjectId', '')
				setProjects([...staticData.projects])
			}
			// Όταν αλλάζει η διεύθυνση επανέφερε τα assets γιατί αλλάζουν ανά διεύθυνση
			formik.setFieldValue('assets', [])
			setAssets([...staticData.assets])
		}
	}, [formik, t, isLoggedIn, userLogout, staticData.customers, staticData.sites, staticData.addresses, staticData.contacts, staticData.projects, formik.values.CustomerId.id, staticData.assets, calculateSLA])
	
	const onChangeService = useCallback((serviceId, addressId) => {
		if (addressId && serviceId) {
			axios({
				method: 'post',
				data: {
					'AddressId': addressId,
					'ItemId': serviceId,
					'ReturnData': ["assets"]
				},
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				url: `${API}/en/issues/issueCustData`
			}).then((res) => {
				const data = res.data
				// Διαχείριση Assets, όταν αλλάζει διεύθυνση, site ή πελάτης ή υπηρεσία
				setAssets(data.assets ? [...data.assets] : [])
				// Όταν αλλάζει η διεύθυνση ή η υπηρεσία επανέφερε τα assets γιατί αλλάζουν ανά διεύθυνση
				formik.setFieldValue('assets', [])
			}).catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'error',
					autoHideDuration: 3000,
				})
				logoutUnauthorizedUser(error, isLoggedIn, userLogout)
			})
		} else {
			// Όταν αλλάζει η διεύθυνση επανέφερε τα assets γιατί αλλάζουν ανά διεύθυνση
			formik.setFieldValue('assets', [])
			setAssets([...staticData.assets])
		}
	}, [formik, t, isLoggedIn, userLogout, staticData.assets])
	
	const handleOnChangeAssignee = useCallback((evt, newValue, reason, field) => {
		if (newValue?.id) {
			// If IntDpt === 1, pre-populate InternalAssignmentId with the same full object
			if (newValue?.isInternalDpt === "1") {
				//formik.setFieldValue('InternalAssignmentId', newValue)
				setSuppliers([newValue])
			} else {
				formik.setFieldValue('InternalAssignmentId', '')
			}
			// λογική για εύρεση τεχνικών που αντιστοιχούν στον Assignee
			axios({
				method: 'post',
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				url: `${API}/en/issue/tech/search`,
				data: {
					AssigneeId: newValue?.id
				}
			}).then((res) => {
				const data = res.data.data
				setTechnicians(data.map(tech => ({
					...tech,
					Description: tech.Description || tech.TechName || tech.Name || ''
				})))
			}).catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'error',
					autoHideDuration: 3000,
				})
				logoutUnauthorizedUser(error, isLoggedIn, userLogout)
			})
		} else {
			formik.setFieldValue('InternalAssignmentId', '')
			setTechnicians([])
		}
		
		if (reason === 'selectOption') {
			const AssigneeId = newValue?.id
			formik.setFieldValue('AssigneeId', newValue)
			// formik.setFieldValue('TechnicianId', [])
			//λογική για εύρεση ομάδας του Assignee
			if (hasEditIssueTeamRight || hasIssueTeamRight) {
				axios({
					method: 'post',
					headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
					url: `${API}/en/issues/getTeams/${AssigneeId}`,
				}).then((res) => {
					const data = res.data
					setUserTeam(data.userTeam)
				}).catch((error) => {
					enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
						variant: 'error',
						autoHideDuration: 3000,
					})
					logoutUnauthorizedUser(error, isLoggedIn, userLogout)
				})
			}
			
		} else if (reason === 'clear') {
			formik.setFieldValue('AssigneeId', '')
			// formik.setFieldValue('TechnicianId', [])
			// formik.setFieldValue('InternalAssignmentId', '')
			formik.setFieldValue('TeamId', [])
			setUsers(staticData.users)
			setUserTeam([]) //για ομάδα
			// setTechnicians([]) //για τεχνικούς
			setSuppliers(staticData.suppliers)
		}
	}, [formik, t, isLoggedIn, userLogout, staticData.users, staticData.suppliers, hasEditIssueTeamRight, hasIssueTeamRight])
	
	const handleCategoryItemChange = useCallback((newValue, reason) => {
		formik.setFieldValue('CategoryItemId', newValue)
		formik.setFieldValue('ItemId', '')
		formik.setFieldValue('assets', [])
		formik.setFieldValue('AssigneeId', '')
		formik.setFieldValue('TechnicianId', [])
		formik.setFieldValue('InternalAssignmentId', '')
		setAssets([])
		setSuppliers(staticData.suppliers)
		if (reason === 'clear') {
			setServiceItems(staticData.serviceItems)
		} else {
			axios({
				method: 'post',
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				data: { 'ItemType': 'service', 'CategId': newValue?.id, 'IsSupport': 1 },
				url: `${API}/en/item/search`
			}).then((response) => {
				setServiceItems(response.data.data)
				if (response.data.data?.length === 1) {
					const item = {
						...response.data.data[0],
						Description: response.data.data[0]?.Description
					}
					formik.setFieldValue('ItemId', item)
					onChangeService(item?.id, formik.values.AddressId?.id)
				}
			}).catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'error',
					autoHideDuration: 3000,
				})
				logoutUnauthorizedUser(error, isLoggedIn, userLogout)
			})
		}
	}, [formik, staticData.serviceItems, staticData.suppliers, t, isLoggedIn, userLogout, onChangeService])
	
	const handleSearch = useCallback((evt, name) => {
		let setter
		let url
		switch (name) {
			case 'customers':
				url = `${API}/en/customers/search`
				setter = setCustomers
				break
			case 'users':
				url = `${API}/en/issue/assignee/search`
				setter = setUsers
				break
			case 'addresses':
				url = `${API}/en/customer/address/search`
				setter = setAddresses
				break
			case 'sites':
				url = `${API}/en/customer/address/search`
				setter = setSites
				break
			case 'items':
				url = `${API}/en/item/search`
				setter = setItems
				break
			case 'projects':
				url = `${API}/en/projects/search`
				setter = setProjects
				break
			case 'suppliers':
				url = `${API}/en/issue/assignee/search`
				setter = setSuppliers
				break
			case 'technician':
				url = `${API}/en/issue/tech/search`
				setter = setTechnicians
				break
			default:
				break
		}
		const data = {
			query: evt.target.value,
			...(name === 'sites' && { Type: 'Site', CustId: formik.values.CustomerId?.id }),
			...(name === 'addresses' && { Type: 'Address', CustId: formik.values.CustomerId?.id }),
			...(name === 'users' && {
				AddressId: formik.values.AddressId?.id,
				ItemId: formik.values.ItemId?.id,
				searchForAddress: formik.values.searchForAddress
			}),
			...(name === 'items' && {
				NotItemType: 'service'
			}),
			...(name === 'technician' && {
				AssigneeId: formik.values.AssigneeId?.id
			}),
			...(name === 'suppliers' && {
				Internal: true
			})
		}
		setLoadingSearch(true)
		axios({
			method: 'post',
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			data,
			url: url
		}).then((response) => {
			if (name === 'technician') {
				setter(response.data.data.map(tech => ({
					...tech,
					Description: tech.Description || tech.TechName || tech.Name || ''
				})))
			} else {
				setter(response.data.data)
			}
			setLoadingSearch(false)
		}).catch((error) => {
			setLoadingSearch(false)
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'error',
				autoHideDuration: 3000,
			})
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}, [formik.values.CustomerId?.id, formik.values.AddressId?.id, formik.values.ItemId?.id, formik.values.searchForAddress, formik.values.AssigneeId?.id, t, isLoggedIn, userLogout])
	
	const handleInternalAssignmentTeamChange = useCallback((evt, newValue, reason) => {
		//const AssigneeId = newValue?.id
		if (reason === 'selectOption') {
			formik.setFieldValue('InternalAssignmentTeamId', newValue)
			// λογική για εύρεση τεχνικών που αντιστοιχούν στον Assignee
			// axios({
			// 	method: 'post',
			// 	headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			// 	url: `${API}/en/issue/assignee/search`,
			// 	data: {
			// 		query: evt?.target?.value || '',
			// 		Internal: true
			// 	}
			// }).then((res) => {
			// 	const data = res.data.data
			// 	setTechnicians(data)
			// }).catch((error) => {
			// 	enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
			// 		variant: 'error',
			// 		autoHideDuration: 3000,
			// 	})
			// 	logoutUnauthorizedUser(error, isLoggedIn, userLogout)
			// })

			axios({
				method: 'post',
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				url: `${API}/en/custom/issues/team/users`,
				data: {
					TeamId: newValue?.id,
				}
			}).then((res) => {
				const data = res.data.data
				setTeamUsers(data)
			}).catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'error',
					autoHideDuration: 3000,
				})
				logoutUnauthorizedUser(error, isLoggedIn, userLogout)
			})


		} else if (reason === 'clear') {
			formik.setFieldValue('InternalAssignmentTeamId', '')
			// formik.setFieldValue('TechnicianId', [])
			setTeams(staticData.teams)
			formik.setFieldValue('InternalAssignmentId', [])
			setTeamUsers([])
		}
	}, [formik, staticData.teams])

	const handleInternalAssignmentChange = useCallback((evt, newValue, reason) => {
		if (reason === 'selectOption') {
			formik.setFieldValue('InternalAssignmentId', newValue)
		} else if (reason === 'clear') {
			formik.setFieldValue('InternalAssignmentId', [])
		}
	}, [formik])

	const handleTimeUnits = useCallback((evt, unitField, valueField) => {
		let newUnit = parseInt(evt.target.value)
		const oldUnit = formik.values[unitField]
		const oldFieldValue = formik.values[valueField]
		formik.setFieldValue(unitField, newUnit)
		formik.setFieldValue(
			valueField,
			timeUnitsConversions(oldFieldValue, oldUnit, newUnit)
		)
	}, [formik])
	
	const handleSearchSerialNum = useCallback((evt, customerVariable) => {
		const CustomerId = formik.values[customerVariable]?.id
		const { SerialNumber } = formik.values
		
		axios.post(`${API}/en/issues/getItemBySN`, { SerialNumber, CustomerId })
		.then((response) => {
			const { SNitem } = response.data
			
			if (SNitem && SNitem.length > 0) {
				const selectedItem = items.find(item => item?.id === SNitem[0]?.id)
				
				if (selectedItem) {
					const { id: ItemId } = selectedItem
					formik.setFieldValue('ItemId', ItemId)
				}
			} else {
				enqueueSnackbar(handleAxiosErrors(t('The serial number does not exist!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
			}
		}).catch((error) => {
			enqueueSnackbar(handleAxiosErrors(error, t('The serial number does not exist!')), {
				variant: 'error',
				autoHideDuration: 3000,
			})
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}, [items, formik, t, isLoggedIn, userLogout])
	
	const handleAddNote = useCallback(() => {
		formik.setFieldValue('Notes', [
			...formik.values.Notes,
			{
				id: uuidv4(),
				Body: '',
			}
		])
	}, [formik])
	
	const handleRemoveNote = useCallback((index) => {
		const updatedNotes = [...formik.values.Notes]
		updatedNotes.splice(index, 1)
		formik.setFieldValue('Notes', updatedNotes);
	}, [formik])

	const handleAddInternalNote = useCallback(() => {
		formik.setFieldValue('InternalNotes', [
			...formik.values.InternalNotes,
			{
				id: uuidv4(),
				Body: '',
			}
		])
	}, [formik])

	const handleRemoveInternalNote = useCallback((index) => {
		const updatedNotes = [...formik.values.InternalNotes]
		updatedNotes.splice(index, 1)
		formik.setFieldValue('InternalNotes', updatedNotes);
	}, [formik])
	
	const onFileChange = useCallback((val, index = null) => {
		const files = formik.values.files ? [...formik.values.files] : []
		if (typeof index === 'number') files.splice(index, 1)
		else val.forEach(file => files.push(file))
		formik.setFieldValue('files', files)
	}, [formik])
	
	const allowActionsOnForm = useMemo(() => (
		((issueIsClosed(issue?.StatusId) && editClosedIssue) || !issueIsClosed(issue?.StatusId))
	), [issue?.StatusId, editClosedIssue])
	
	return (
		<FormikProvider value={formik}>
			<Box
				component={'form'}
				autoComplete="off"
				onSubmit={formik.handleSubmit}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					width: '100%',
				}}
			>
				<PageContentWrapper>
					<Grid container rowSpacing={1}>
						<Grid size={{ xs: 12, sm: 4, md: 4 }}>
							<PageMenu>
								{!fromDashboard && (
									<NavigateBackButton
										title={t('Return')}
										fallBackRoute={fromDashboard ? getRouteUrl(ROUTE_PAGE_HOME) : getRouteUrl(ROUTE_PAGE_ISSUES_INDEX)}
									/>
								)}
								<Button
									loading={loadingSubmit}
									startIcon={<SaveIcon/>}
									onClick={formik.handleSubmit}
									variant="contained"
									sx={{
										marginLeft: 'auto'
									}}
									disabled={!allowActionsOnForm}
								>
									{t('Save')}
								</Button>
							</PageMenu>
						</Grid>
						<Grid size={{ xs: 12, sm: 8, md: 8 }}>
							{IssueId &&
								<Box
									sx={{
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center',
										flexWrap: 'wrap',
										gap: 1, // MUI spacing unit (1.5 * 8px = 12px)
									}}
								>
									{/*<PermissionHOC requiredPermissions={[view_checklists]}>*/}
										<Button
											size={'small'}
											variant={'contained'}
											sx={{
												width: {
													xs: '100%',
													sm: 'auto'
												},
											}}
											onClick={() => {
												history.push(getRouteUrl(ROUTE_PAGE_ISSUE_CHECKLISTS, { IssueId: IssueId, Description: issue?.Description }))
											}}
										>
											<Checklist fontSize="small"/>
											{t('Checklists')}
										</Button>
									{/*</PermissionHOC>*/}
									<PermissionHOC requiredPermissions={[issue_so_order]}>
										<Button
											size={'small'}
											variant={'contained'}
											sx={{
												width: {
													xs: '100%',
													sm: 'auto'
												},
												backgroundColor: '#F1F8E9'
											}}
											onClick={() => {
												setOpenSOForm(true)
											}}
											disabled={!allowActionsOnForm}
										>
											<EuroRounded fontSize="small"/>
											{t('Offer')}
										</Button>
									</PermissionHOC>
									<FollowUpButton issueId={IssueId}/>
									<PermissionHOC requiredPermissions={[issue_complete]}>
										<Button
											size={'small'}
											variant={'contained'}
											color={'success'}
											sx={{
												width: {
													xs: '100%',
													sm: 'auto'
												}
											}}
											onClick={() => {
												onActionClick(IssueStatus.Epilithike)
											}}
											disabled={!allowActionsOnForm}
										>
											{t('Complete')}
										</Button>
									</PermissionHOC>
									<PermissionHOC requiredPermissions={[issue_pending]}>
										<Button
											size={'small'}
											variant={'contained'}
											color={'warning'}
											onClick={() => {
												onActionClick(IssueStatus.AnamoniAntallaktikon)
											}}
											sx={{
												width: {
													xs: '100%',
													sm: 'auto'
												}
											}}
											disabled={!allowActionsOnForm}
										>
											{t('Pending')}
										</Button>
									</PermissionHOC>
									<PermissionHOC requiredPermissions={[issue_inability]}>
										<Button
											size={'small'}
											variant={'contained'}
											color={'info'}
											onClick={() => {
												onActionClick(IssueStatus.Akurothike)
											}}
											sx={{
												width: {
													xs: '100%',
													sm: 'auto'
												}
											}}
											disabled={!allowActionsOnForm}
										>
											{t('Inability')}
										</Button>
									</PermissionHOC>
									<PermissionHOC requiredPermissions={[issue_cancel]}>
										<Button
											size={'small'}
											variant={'contained'}
											color={'error'}
											sx={{
												width: {
													xs: '100%',
													sm: 'auto'
												}
											}}
											disabled={!allowActionsOnForm}
											onClick={() => {
												onActionClick(IssueStatus.Akurothike)
											}}
										>
											{t('Cancel')}
										</Button>
									</PermissionHOC>
								</Box>
							}
						</Grid>
					</Grid>
					<PageTitle
						withDivider
						title={!IssueId ? t('New Issue') : (IssueId && Copy) ? t('Copy Issue') : t('Edit Issue')}
					/>
					<Grid
						container
						spacing={3}
					>
						<Grid
							size={{ xs: 12, sm: 6, md: 6 }}
						>
							<FormBoxTitle title={t('General Information')}/>
							<Box>
								<Grid
									container
									spacing={2}
								>
									{IssueId && (
										<>
											<Grid size={{ xs: 12, sm: 6 }}>
												<FormControl
													{...formControlDefaults}
												>
													<FormLabel>{t('Code')}</FormLabel>
													<TextField
														{...textFieldDefaults}
														name={'Code'}
														value={formik.values.Code}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														disabled
													/>
												</FormControl>
											</Grid>
											<PermissionHOC
												requiredPermissions={[issue_view_erp_code]}>
												<Grid size={{ xs: 12, sm: 6 }}>
													<FormControl
														{...formControlDefaults}
													>
														<FormLabel>{t('Erp Code')}</FormLabel>
														<TextField
															{...textFieldDefaults}
															name={'ErpCode'}
															value={formik.values.ErpCode}
															onChange={formik.handleChange}
															onBlur={formik.handleBlur}
															disabled
														/>
													</FormControl>
												</Grid>
											</PermissionHOC>
										</>
									)}
									<PermissionHOC
										requiredPermissions={[IssueId ? issue_edit_reference_code : issue_reference_code]}>
										<Grid size={{ xs: 12, sm: 6 }}>
											<FormControl
												{...formControlDefaults}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? issue_edit_reference_code : issue_reference_code]}>
													<FormLabel>{t('Reference Code')}</FormLabel>
													<TextField
														{...textFieldDefaults}
														name={'ErpCode2'}
														value={formik.values.ErpCode2}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
													/>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? issue_edit_reference_code : issue_reference_code]}>
										<Grid size={{ xs: 12, sm: 6 }}>
											<FormControl
												{...formControlDefaults}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? issue_edit_reference_code : issue_reference_code]}>
													<FormLabel>{t('Customer PO Code')}</FormLabel>
													<TextField
														{...textFieldDefaults}
														name={'CPOCode'}
														value={formik.values.CPOCode}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
													/>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<Grid size={12}>
										<Box>
											<Grid container spacing={2}>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_active : issue_active]}>
													<Grid size={{ xs: 6 }}>
														<FormControl
															{...formControlDefaults}
														>
															<FormControlLabel
																control={
																	<Checkbox
																		checked={formik.values.isActive}
																		onChange={formik.handleChange}
																		name="isActive"
																		onBlur={formik.handleBlur}
																	/>
																}
																label={<FormLabel>{t('Active')}</FormLabel>}
															/>
														</FormControl>
													</Grid>
												</PermissionHOC>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_billable : issue_billable]}>
													<Grid size={{ xs: 6 }}>
														<FormControl
															{...formControlDefaults}
														>
															<FormControlLabel
																control={
																	<Checkbox
																		checked={formik.values.isBillable}
																		onChange={formik.handleChange}
																		name="isBillable"
																		onBlur={formik.handleBlur}
																	/>
																}
																label={<FormLabel>{t('Billable')}</FormLabel>}
															/>
														</FormControl>
													</Grid>
												</PermissionHOC>
											</Grid>
										</Box>
									</Grid>
									<Grid size={{ xs: 12 }}>
										<FormControl
											{...formControlDefaults}
											error={
												formik.touched['Description'] &&
												Boolean(formik.errors['Description'])
											}
										>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_description : issue_description]}>
												<FormLabel required>{t('Description')}</FormLabel>
												<TextField
													{...textFieldDefaults}
													name={'Description'}
													value={formik.values.Description}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													placeholder={t('Enter issue\'s description')}
													slotProps={{
														htmlInput: {
															maxLength: 250,
														}
													}}
												/>
												<FormHelperText>
													<ErrorMessage name={'Description'}/>
												</FormHelperText>
											</PermissionHOC>
										</FormControl>
									</Grid>
									<Grid size={{ xs: 12 }}>
										<FormControl
											{...formControlDefaults}
										>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_summary : issue_summary]}>
												<FormLabel>{t('Summary')}</FormLabel>
												<TextField
													{...textFieldDefaults}
													multiline
													rows={4}
													name={'Summary'}
													value={formik.values.Summary}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
												/>
											</PermissionHOC>
										</FormControl>
									</Grid>
									<Grid size={12}>
										<Box>
											<Grid container spacing={2}>
												
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_owner : issue_owner]}>
													<Grid
														size={{ xs: 12, sm: 6, md: 6 }}
													>
														<FormControl
															{...formControlDefaults}
														>
															<FormLabel>{t('Creator')}</FormLabel>
															<TextField
																{...textFieldDefaults}
																name={'Creator'}
																value={formik.values.Creator}
																onChange={formik.handleChange}
																onBlur={formik.handleBlur}
																disabled
															/>
														</FormControl>
													</Grid>
												</PermissionHOC>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_submit_date : issue_submit_date]}>
													<Grid size={{ xs: 12, sm: 6, md: 6 }}>
														<FormControl
															{...formControlDefaults}
														>
															<PermissionHOC
																requiredPermissions={[IssueId ? edit_issue_submit_date : issue_submit_date]}>
																<FormLabel>{t('Submit Dt')}</FormLabel>
																<DateTimePicker
																	slotProps={{
																		textField: {
																			size: 'small',
																			variant: 'standard'
																		}
																	}}
																	name="SubmitDt"
																	views={['year', 'month', 'day']}
																	format={`${dateFormat} ${timeFormat}`}
																	value={formik.values.SubmitDt}
																	onChange={(newValue) => {
																		formik.setFieldValue('SubmitDt', newValue)
																	}}
																	onBlur={formik.handleBlur}
																	maxDate={(IssueId && formik.initialValues.SubmitDt) ? formik.initialValues.SubmitDt : undefined}
																/>
															</PermissionHOC>
														</FormControl>
													</Grid>
												</PermissionHOC>
											</Grid>
										</Box>
									</Grid>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_actual_start : issue_actual_start]}>
										<Grid size={{ xs: 12, sm: 6, md: 6 }}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['ActualStartDt'] &&
													Boolean(formik.errors['ActualStartDt'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_actual_start : issue_actual_start]}>
													<FormLabel>{t('Actual Start')}</FormLabel>
													<DateTimePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														ampm={false}
														name="ActualStarDt"
														format={`${dateFormat} ${timeFormat}`}
														value={formik.values.ActualStartDt}
														onChange={(newValue) => {
															formik.setFieldValue('ActualStartDt', newValue);
														}}
														onBlur={() => formik.setFieldTouched('ActualEndDt', true)}
													/>
													<FormHelperText>
														<ErrorMessage name={'ActualStartDt'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_actual_end : issue_actual_end]}>
										<Grid size={{ xs: 12, sm: 6, md: 6 }}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['ActualEndDt'] &&
													Boolean(formik.errors['ActualEndDt'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_actual_end : issue_actual_end]}>
													<FormLabel>{t('Actual End')}</FormLabel>
													<DateTimePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="ActualEndDt"
														ampm={false}
														format={`${dateFormat} ${timeFormat}`}
														value={formik.values.ActualEndDt}
														onChange={(newValue) => {
															formik.setFieldValue('ActualEndDt', newValue);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'ActualEndDt'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
										{/*<Grid size={{ xs: 12, sm: 6, md: 6 }}>*/}
										{/*	<FormControl*/}
										{/*		{...formControlDefaults}*/}
										{/*		error={*/}
										{/*			formik.touched['SubmitDt'] &&*/}
										{/*			Boolean(formik.errors['SubmitDt'])*/}
										{/*		}*/}
										{/*	>*/}
										{/*	<FormLabel>{t('Date Registered')}</FormLabel>*/}
										{/*		<DateTimePicker*/}
										{/*			slotProps={{*/}
										{/*				textField: {*/}
										{/*					size: 'small',*/}
										{/*					variant: 'standard'*/}
										{/*				}*/}
										{/*			}}*/}
										{/*			name="DateReg"*/}
										{/*			ampm={false}*/}
										{/*			disableFuture*/}
										{/*			format={`${dateFormat} ${timeFormat}`}*/}
										{/*			value={formik.values.SubmitDt}*/}
										{/*			onChange={(newValue) => {*/}
										{/*				formik.setFieldValue('SubmitDt', newValue);*/}
										{/*			}}*/}
										{/*			onBlur={formik.handleBlur}*/}
										{/*		/>*/}
										{/*		<FormHelperText>*/}
										{/*			<ErrorMessage name={'DateReg'}/>*/}
										{/*		</FormHelperText>*/}
										{/*	</FormControl>*/}
										{/*</Grid>*/}
									</PermissionHOC>
								</Grid>
							</Box>
						</Grid>
						<Grid
							size={{ xs: 12, sm: 6, md: 6 }}
						>
							<FormBoxTitle title={t('Customer Details')}/>
							<Box>
								<Grid
									container
									spacing={1}
								>
									<Grid size={{ xs: 12 }}>
										<FormControl
											{...formControlDefaults}
											error={
												formik.touched['CustomerId'] &&
												Boolean(formik.errors['CustomerId'])
											}
										>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_customer : issue_customer]}>
												<FormLabel required>{t('Customer')}</FormLabel>
												<CustomAutocomplete
													identifier={'id'}
													value={formik.values.CustomerId}
													onChange={(evt, newValue, reason) => onChangeAddressCustomerSiteService(newValue, reason, 'customers')}
													onBlur={formik.handleBlur}
													options={customers}
													labelKey={'Description'}
													onInputChange={(event) => handleSearch(event, 'customers')}
													otherprops={{
														selectOnFocus: true,
														handleHomeEndKeys: true,
														getOptionKey: (option) => (option?.id)
													}}
													loading={loadingSearch}
												/>
												<FormHelperText>
													<ErrorMessage name={'CustomerId'}/>
												</FormHelperText>
											</PermissionHOC>
										</FormControl>
									</Grid>
									{formik.values.CustomerId?.id && (
										<PermissionHOC requiredPermissions={[issue_customer_contact_info]}>
											<Grid size={12}>
												<FormLabel>{t('Main Contact')}</FormLabel>
												<Box sx={{ padding: 0.4, background: '#f5f5f5', marginBottom: 0.8 }}>
													<Typography
														variant={'body1'}
													>
														<strong>{t('Name')}</strong>: {formik.values.CustomerId?.MainContactName ? formik.values.CustomerId?.MainContactName : '-'}
													</Typography>
													<Typography
														variant={'body1'}
													>
														<strong>{t('Email')}</strong>: {formik.values.CustomerId?.MainContactEmail ? formik.values.CustomerId?.MainContactEmail : '-'}
													</Typography>
													<Typography
														variant={'body1'}
													>
														<strong>{t('Phone')}</strong>: {formik.values.CustomerId?.MainContactPhone ? formik.values.CustomerId?.MainContactPhone : '-'}
													</Typography>
												</Box>
											</Grid>
										</PermissionHOC>
									)}
									<Grid size={{ xs: 12 }}>
										<FormControl
											{...formControlDefaults}
										>
											<FormLabel>{t('Site')}</FormLabel>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_site : issue_site]}>
												<CustomAutocomplete
													identifier={'id'}
													value={formik.values.Site}
													onChange={(evt, newValue, reason) => onChangeAddressCustomerSiteService(newValue, reason, 'sites')}
													onBlur={formik.handleBlur}
													options={sites}
													labelKey={'Description'}
													onInputChange={(event) => handleSearch(event, 'sites')}
													otherprops={{
														selectOnFocus: true,
														handleHomeEndKeys: true,
														getOptionKey: (option) => (option?.id)
													}}
													loading={loadingSearch}
												/>
											</PermissionHOC>
										</FormControl>
									</Grid>
									<Grid size={{ xs: 12 }}>
										<FormControl
											{...formControlDefaults}
											error={
												formik.touched['AddressId'] &&
												Boolean(formik.errors['AddressId'])
											}
										>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_address : issue_address]}>
												<FormLabel required>{t('Address')}</FormLabel>
												<CustomAutocomplete
													identifier={'id'}
													value={formik.values.AddressId}
													onChange={(evt, newValue, reason) => onChangeAddressCustomerSiteService(newValue, reason, 'addresses')}
													onBlur={formik.handleBlur}
													options={addresses}
													labelKey={'Description'}
													onInputChange={(event) => handleSearch(event, 'addresses')}
													otherprops={{
														selectOnFocus: true,
														handleHomeEndKeys: true,
														getOptionKey: (option) => (option?.id)
													}}
													loading={loadingSearch}
												/>
												<FormHelperText>
													<ErrorMessage name={'AddressId'}/>
												</FormHelperText>
											</PermissionHOC>
										</FormControl>
									</Grid>
									<PermissionHOC requiredPermissions={[issue_fm_info]}>
										{formik.values.AddressId?.id && (
											<Grid size={12}>
												<FormLabel>{t('FM')}</FormLabel>
												<Box sx={{ padding: 0.4, background: '#f5f5f5', marginBottom: 0.8 }}>
													<Typography
														variant={'body1'}
													>
														<strong>{t('Name')}</strong>: {formik.values.AddressId?.FmName ? formik.values.AddressId?.FmName : '-'}
													</Typography>
													<Typography
														variant={'body1'}
													>
														<strong>{t('Email')}</strong>: {formik.values.AddressId?.FmEmail ? formik.values.AddressId?.FmEmail : '-'}
													</Typography>
												</Box>
											</Grid>
										)}
									</PermissionHOC>
									<Grid size={{ xs: 12 }}>
										<FormControl
											{...formControlDefaults}
										>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_address_contact : issue_address_contact]}>
												<FormLabel>{t('Contact')}</FormLabel>
												<CustomAutocomplete
													identifier={'id'}
													value={formik.values?.ContactId}
													onChange={(evt, newValue, reason) => formik.setFieldValue('ContactId', newValue)}
													onBlur={formik.handleBlur}
													options={contacts}
													labelKey={'Description'}
													otherprops={{
														selectOnFocus: true,
														handleHomeEndKeys: true,
														getOptionKey: (option) => (option?.id)
													}}
													disabled={(!formik.values.CustomerId?.id || !formik.values.AddressId?.id)}
												/>
											</PermissionHOC>
										</FormControl>
									</Grid>
									{formik.values.ContactId?.id && (
										<PermissionHOC requiredPermissions={[issue_address_contact_info]}>
											<Grid size={12}>
												<FormLabel>{t('Contact Info')}</FormLabel>
												<Box sx={{ padding: 0.4, background: '#f5f5f5', marginBottom: 0.8 }}>
													<Typography
														variant={'body1'}
													>
														<strong>{t('Email')}</strong>: {formik.values.ContactId?.ContactEmail ? formik.values.ContactId?.ContactEmail : '-'}
													</Typography>
													<Typography
														variant={'body1'}
													>
														<strong>{t('Phone')}</strong>: {formik.values.ContactId?.ContactPhone ? formik.values.ContactId?.ContactPhone : '-'}
													</Typography>
												</Box>
											</Grid>
										</PermissionHOC>
									)}
									<Grid size={{ xs: 12 }}>
										<FormControl
											{...formControlDefaults}
										>
											<FormLabel>{t('Applicant')}</FormLabel>
											<TextField
												{...textFieldDefaults}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												value={formik.values.ContactNameText}
												name={'ContactNameText'}
											>
											</TextField>
										</FormControl>
									</Grid>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_project : issue_project]}>
										<Grid size={{ xs: 12 }}>
											<FormControl
												{...formControlDefaults}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_project : issue_project]}>
													<FormLabel>{t('Project')}</FormLabel>
													<CustomAutocomplete
														identifier={'id'}
														value={formik.values.PrjId?.id}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														options={projects}
														labelKey={'Description'}
														otherprops={{
															selectOnFocus: true,
															getOptionKey: (option) => (option?.id)
														}}
														disabled={(!formik.values.CustomerId?.id || !formik.values.AddressId?.id)}
													/>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_serial_number : issue_serial_number]}>
										<Grid size={{ xs: 12 }}>
											<Box
												display={'flex'}
												flexDirection={'row'}
												alignItems={'end'}
												justifyContent={'space-between'}
											>
												<FormControl
													{...formControlDefaults}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_serial_number : issue_serial_number]}>
														<FormLabel>{t('Serial Number')}</FormLabel>
														<TextField
															{...textFieldDefaults}
															value={formik.values.SerialNumber}
															onChange={formik.handleChange}
															onBlur={formik.handleBlur}
															name={'SerialNumber'}
															slotProps={{
																htmlInput: {
																	maxLength: 50
																}
															}}
														/>
													</PermissionHOC>
												</FormControl>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_serial_number : issue_serial_number]}>
													<IconButton
														onClick={(evt) => handleSearchSerialNum(evt, 'CustomerId')}
													>
														<SearchIcon/>
													</IconButton>
												</PermissionHOC>
											</Box>
										</Grid>
									</PermissionHOC>
									<PermissionHOC requiredPermissions={[IssueId ? edit_issue_sla : issue_sla]}>
										<Grid size={{ xs: 12 }}>
											<PermissionHOC requiredPermissions={[IssueId ? edit_issue_sla : issue_sla]}>
												<FormLabel>{t('SLA')}</FormLabel>
												<TextField
													{...textFieldSelectDefaults}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													value={formik.values.SLAId}
													name={'SLAId'}
													disabled={!formik.values.ItemId}
												>
													{slas?.map((sla) => (
														<MenuItem
															dense
															key={sla?.id}
															value={sla?.id}
														>
															{sla.Description}
														</MenuItem>
													))}
												</TextField>
											</PermissionHOC>
										</Grid>
									</PermissionHOC>
								</Grid>
							</Box>
						</Grid>
						<Grid size={12}>
							<Box>
								<Grid container spacing={2}>
									<Grid size={12}>
										<FormBoxTitle
											title={t('Technical Details')}
										/>
									</Grid>
									<Grid size={{ xs: 12, sm: 12, md: 6, lg: 5 }}>
										<FormControl
											{...formControlDefaults}
										>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_service_category : issue_service_category]}>
												<FormLabel>{t('Service Category')}</FormLabel>
												<CustomAutocomplete
													identifier={'id'}
													value={formik.values.CategoryItemId}
													onChange={(evt, newValue, reason) => {
														handleCategoryItemChange(newValue, reason)
													}}
													onBlur={formik.handleBlur}
													options={staticData.categories}
													labelKey={'Description'}
													otherprops={{
														selectOnFocus: true,
														getOptionKey: (option) => (option?.id)
													}}
												/>
											</PermissionHOC>
										</FormControl>
									</Grid>
									<Grid size={{ xs: 12, sm: 12, md: 6, lg: 7 }}>
										<FormControl
											{...formControlDefaults}
										>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_service : issue_service]}>
												<FormLabel>{t('Service')}</FormLabel>
												<CustomAutocomplete
													identifier={'id'}
													value={formik.values.ItemId}
													onChange={(evt, newValue) => {
														formik.setFieldValue('ItemId', newValue)
														formik.setFieldValue('AssigneeId', '')
														formik.setFieldValue('TechnicianId', [])
														formik.setFieldValue('InternalAssignmentId', '')
														setSuppliers(staticData.suppliers)
														onChangeService(newValue?.id, formik.values.AddressId?.id)
													}}
													onBlur={formik.handleBlur}
													options={serviceItems}
													labelKey={'Description'}
													disabled={!formik.values.CategoryItemId?.id}
													otherprops={{
														selectOnFocus: true
													}}
												/>
											</PermissionHOC>
										</FormControl>
									</Grid>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_team : issue_team]}>
										<Grid
											size={{ xs: 12 }}
										>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['TeamId'] &&
													Boolean(formik.errors['TeamId'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_team : issue_team]}>
													<FormLabel required>{t('Team')}</FormLabel>
													<TextField
														{...textFieldSelectDefaults}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.TeamId}
														name={'TeamId'}
													>
														{userTeam.map((team) => (
															<MenuItem
																dense
																key={team?.id}
																value={team?.id}
															>
																{team.Description}
															</MenuItem>
														))}
													</TextField>
													<FormHelperText>
														<ErrorMessage name={'TeamId'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>


										<Grid size={{ xs: 12, sm: 12, md: 8, lg: 6 }}>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_assignee : issue_assignee]}>
												<Grid
													size={{ xs: 12 }}
													sx={{ display: 'flex', alignItems: 'flex-end',mb:2 }}
												>
													<FormControl
														{...formControlDefaults}
														error={
															formik.touched['AssigneeId'] &&
															Boolean(formik.errors['AssigneeId'])
														}
													>
														<PermissionHOC
															requiredPermissions={[IssueId ? edit_issue_assignee : issue_assignee]}>
															<FormLabel>{t('Subcontractor')}</FormLabel>
															<CustomAutocomplete
																identifier={'id'}
																value={formik.values.AssigneeId}
																onChange={(evt, newValue, reason) => handleOnChangeAssignee(evt, newValue, reason)}
																onBlur={formik.handleBlur}
																options={users}
																labelKey={'Description'}
																onInputChange={(event) => handleSearch(event, 'users')}
																otherprops={{
																	handleHomeEndKeys: true,
																	getOptionKey: (option) => (option?.id)
																}}
																loading={loadingSearch}
																disabled={!(formik.values.AddressId?.id && formik.values.ItemId?.id)}
															/>
														</PermissionHOC>
													</FormControl>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_assignee : issue_assignee]}>
														<Tooltip title={t('Search Address Suppliers')}>
															<FormControlLabel
																control={
																	<Checkbox
																		checked={formik.values.searchForAddress}
																		onChange={formik.handleChange}
																		name="searchForAddress"
																		onBlur={formik.handleBlur}
																	/>
																}
																label={''}
															/>
														</Tooltip>
													</PermissionHOC>
												</Grid>
											</PermissionHOC>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_technicians : issue_technicians]}>
												<Grid size={{ xs: 12 }} sx={{mb:2}}>
													<FormControl
														{...formControlDefaults}
													>
														<PermissionHOC
															requiredPermissions={[IssueId ? edit_issue_technicians : issue_technicians]}>
															<FormLabel>{t('Technicians')}</FormLabel>
															<CustomAutocomplete
																identifier="id"
																value={formik.values.TechnicianId}
																onChange={(evt, newValue) => formik.setFieldValue('TechnicianId', newValue)}
																onBlur={formik.handleBlur}
																options={technicians}
																labelKey={'Description'}
																onInputChange={(event) => handleSearch(event, 'technician')}
																loading={loadingSearch}
																disabled={!formik.values.AssigneeId?.id}
																otherprops={{
																	multiple: true,
																	disableCloseOnSelect: true,
																	getOptionKey: (option) => (option?.id)
																}}
															/>
														</PermissionHOC>
													</FormControl>
												</Grid>
											</PermissionHOC>
										</Grid>
										<Grid size={{ xs: 12, sm: 12, md: 8, lg: 6 }}>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_assignee : issue_assignee]}>
												<Grid size={{ xs: 12 }} sx={{mb:2}}>
													<FormControl
														{...formControlDefaults}
													>
														<PermissionHOC
															requiredPermissions={[IssueId ? edit_issue_assignee : issue_assignee]}>
															<FormLabel>{t('Internal Assignment')}</FormLabel>
															<CustomAutocomplete
																identifier="id"
																value={formik.values.InternalAssignmentTeamId}
																onChange={(evt, newValue, reason) => handleInternalAssignmentTeamChange(evt, newValue, reason)}
																onBlur={formik.handleBlur}
																options={teams || []}
																labelKey={'Description'}
																loading={loadingSearch}
																otherprops={{
																	handleHomeEndKeys: true,
																	getOptionKey: (option) => (option?.id),
																	isOptionEqualToValue: (option, value) =>
																		String(option?.id) === String(value?.id),
																}}
															/>
														</PermissionHOC>
													</FormControl>
												</Grid>
											</PermissionHOC>
											<PermissionHOC
												requiredPermissions={[IssueId ? edit_issue_assignee : issue_assignee]}>
												<Grid size={{ xs: 12 }} sx={{mb:2}}>
													<FormControl
														{...formControlDefaults}
													>
														<PermissionHOC
															requiredPermissions={[IssueId ? edit_issue_assignee : issue_assignee]}>
															<FormLabel>{t('Face Internal Assignment')}</FormLabel>
															<CustomAutocomplete
																identifier="id"
																value={formik.values.InternalAssignmentId}
																onChange={(evt, newValue, reason) => handleInternalAssignmentChange(evt, newValue, reason)}
																onBlur={formik.handleBlur}
																options={teamUsers || []}
																labelKey={'Description'}
																loading={loadingSearch}
																otherprops={{
																	handleHomeEndKeys: true,
																	getOptionKey: (option) => (option?.id),
																	isOptionEqualToValue: (option, value) =>
																		String(option?.id) === String(value?.id),
																}}
															/>
														</PermissionHOC>
													</FormControl>
												</Grid>
											</PermissionHOC>
										</Grid>
								</Grid>
							</Box>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
							<Box>
								<Grid container spacing={2}>
									<Grid size={{ xs: 12 }}>
										<FormBoxTitle
											title={t('Status')}
										/>
									</Grid>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_status : issue_status]}>
										<Grid size={12}>
											<Grid size={{ xs: 12 }}>
												<FormControl
													{...formControlDefaults}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_status : issue_status]}>
														<FormLabel>{t('Status')}</FormLabel>
														<TextField
															{...textFieldSelectDefaults}
															onChange={formik.handleChange}
															onBlur={formik.handleBlur}
															value={formik.values.StatusId}
															name={'StatusId'}
														>
															<MenuItem value={''} sx={{ padding: 1 }}/>
															{staticData.statuses.map(status => (
																<MenuItem
																	key={status?.id}
																	value={status?.id}
																>{status.Description}</MenuItem>
															))}
														</TextField>
													</PermissionHOC>
												</FormControl>
											</Grid>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_priority : issue_priority]}>
										<Grid size={12}>
											<Grid size={{ xs: 12 }}>
												<FormControl
													{...formControlDefaults}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_priority : issue_priority]}>
														<FormLabel>{t('Priority')}</FormLabel>
														<TextField
															{...textFieldSelectDefaults}
															onChange={(evt) => {
																formik.setFieldValue('PriorityId', evt.target.value)
																calculateSLA({
																	custId: formik.values.CustomerId?.id,
																	priorityId: evt.target.value
																})
															}}
															onBlur={formik.handleBlur}
															value={formik.values.PriorityId}
															name={'PriorityId'}
														>
															<MenuItem value={''} sx={{ padding: 1 }}/>
															{staticData.priorities.map((priority) => (
																<MenuItem
																	key={priority?.id}
																	value={priority?.id}
																>
																	{priority.Description}
																</MenuItem>
															))}
														</TextField>
													</PermissionHOC>
												</FormControl>
											</Grid>
										</Grid>
									</PermissionHOC>
									<PermissionHOC requiredPermissions={[IssueId ? edit_issue_type : issue_type]}>
										<Grid size={12}>
											<Grid size={{ xs: 12 }}>
												<FormControl
													{...formControlDefaults}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_type : issue_type]}>
														<FormLabel>{t('Dimension')}</FormLabel>
														<TextField
															{...textFieldSelectDefaults}
															onChange={formik.handleChange}
															onBlur={formik.handleBlur}
															value={formik.values.TypeId}
															name={'TypeId'}
														>
															<MenuItem value={''} sx={{ padding: 1 }}/>
															{staticData.types.map((type) => (
																<MenuItem
																	key={type?.id}
																	value={type?.id}
																>
																	{type.Description}
																</MenuItem>
															))}
														</TextField>
													</PermissionHOC>
												</FormControl>
											</Grid>
										</Grid>
									</PermissionHOC>
									<PermissionHOC requiredPermissions={[IssueId ? edit_issue_kind : issue_kind]}>
										<Grid size={12}>
											<FormControl
												{...formControlDefaults}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_kind : issue_kind]}>
													<FormLabel>{t('Issue Type')}</FormLabel>
													<TextField
														{...textFieldSelectDefaults}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.KindId}
														name={'KindId'}
													>
														{staticData.kinds.map(kind => (
															<MenuItem
																key={kind?.id}
																value={kind?.id}
															>{kind.Description}</MenuItem>
														))}
													</TextField>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<Grid size={12}>
										<FormControl
											{...formControlDefaults}
										>
											<FormLabel>{t('Alternative Type')}</FormLabel>
											<CustomAutocomplete
												identifier={'id'}
												value={formik.values.Type2}
												onChange={(evt, newValue, reason) => {
													formik.setFieldValue('Type2', newValue);
												}}
												onBlur={formik.handleBlur}
												options={staticData.types2}
												labelKey={'Description'}
												otherprops={{
													selectOnFocus: true,
													getOptionKey: (option) => (option?.id)
												}}
											/>
										</FormControl>
									</Grid>
								</Grid>
							</Box>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
							<Box>
								<Grid container spacing={2} sx={{alignItems: 'end'}}>
									<Grid size={{ xs: 12 }}>
										<FormBoxTitle
											title={t('Timeline')}
										/>
									</Grid>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_targeted_start : issue_targeted_start]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 7,
											lg: fromDashboard ? 12 : 7,
											xl: fromDashboard ? 6 : 7
										}}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['TargetedStartDt'] &&
													Boolean(formik.errors['TargetedStartDt'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_targeted_start : issue_targeted_start]}>
													<FormLabel>{t('Targeted Start')}</FormLabel>
													<DatePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="TargetedStartDt"
														views={['year', 'month', 'day']}
														format={dateFormat}
														value={formik.values.TargetedStartDt}
														onChange={(newValue) => {
															formik.setFieldValue('TargetedStartDt', newValue)
														}}
														onBlur={formik.handleBlur}
														disabled={formik.values.PriorityId !== PriorityPlanned}
													/>
													<FormHelperText>
														<ErrorMessage name={'TargetedStartDt'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_targeted_start : issue_targeted_start]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 5,
											lg: fromDashboard ? 12 : 5,
											xl: fromDashboard ? 6 : 5
										}}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['TargetedStartTm'] &&
													Boolean(formik.errors['TargetedStartTm'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_targeted_start : issue_targeted_start]}>
													<FormLabel>{t('Targeted Start Time')}</FormLabel>
													<TimePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="TargetedStartTm"
														format={timeFormat}
														ampm={false}
														value={formik.values.TargetedStartTm}
														onChange={(newValue) => {
															formik.setFieldValue('TargetedStartTm', newValue);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'TargetedStartTm'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_actual_visit_date : issue_actual_visit_date]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 7,
											lg: fromDashboard ? 12 : 7,
											xl: fromDashboard ? 6 : 7
										}}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['ActualVisitDt'] &&
													Boolean(formik.errors['ActualVisitDt'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_actual_visit_date : issue_actual_visit_date]}>
													<FormLabel>{t('Actual Visit Date')}</FormLabel>
													<DatePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="ActualVisitDt"
														views={['year', 'month', 'day']}
														format={dateFormat}
														value={formik.values.ActualVisitDt}
														onChange={(newValue) => {
															formik.setFieldValue('ActualVisitDt', newValue)
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'ActualVisitDt'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_actual_visit_date : issue_actual_visit_date]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 5,
											lg: fromDashboard ? 12 : 5,
											xl: fromDashboard ? 6 : 5
										}}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['ActualVisitTm'] &&
													Boolean(formik.errors['ActualVisitTm'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_actual_visit_date : issue_actual_visit_date]}>
													<FormLabel>{t('Actual Visit Time')}</FormLabel>
													<TimePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="ActualVisitTm"
														format={timeFormat}
														ampm={false}
														value={formik.values.ActualVisitTm}
														onChange={(newValue) => {
															formik.setFieldValue('ActualVisitTm', newValue);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'ActualVisitTm'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_targeted_end : issue_targeted_end]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 7,
											lg: fromDashboard ? 12 : 7,
											xl: fromDashboard ? 6 : 7
										}}
											  sx={{ display: 'flex', flexDirection: 'row' }}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['TargetedEndDt'] &&
													Boolean(formik.errors['TargetedEndDt'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_targeted_end : issue_targeted_end]}>
													<FormLabel>{t('Targeted Expiry')}</FormLabel>
													<DatePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="TargetedEndDt"
														views={['year', 'month', 'day']}
														format={dateFormat}
														value={formik.values.TargetedEndDt}
														onChange={(newValue) => {
															formik.setFieldValue('TargetedEndDt', newValue);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'TargetedEndDt'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_targeted_end : issue_targeted_end]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 5,
											lg: fromDashboard ? 12 : 5,
											xl: fromDashboard ? 6 : 5
										}}
											  sx={{ display: 'flex', flexDirection: 'row' }}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['TargetedEndTm'] &&
													Boolean(formik.errors['TargetedEndTm'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_targeted_end : issue_targeted_end]}>
													<FormLabel>{t('Targeted Expiry Time')}</FormLabel>
													<TimePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="TargetedEndTm"
														ampm={false}
														format={timeFormat}
														value={formik.values.TargetedEndTm}
														onChange={(newValue) => {
															formik.setFieldValue('TargetedEndTm', newValue);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'TargetedEndTm'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_estimated_start : issue_estimated_start]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 7,
											lg: fromDashboard ? 12 : 7,
											xl: fromDashboard ? 6 : 7
										}}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['EstimStartDt'] &&
													Boolean(formik.errors['EstimStartDt'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_estimated_start : issue_estimated_start]}>
													<FormLabel>{t('Est. Start')}</FormLabel>
													<DatePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="EstimStartDt"
														views={['year', 'month', 'day']}
														format={dateFormat}
														value={formik.values.EstimStartDt}
														onChange={(newValue) => {
															formik.setFieldValue('EstimStartDt', newValue);
															const checkIfBefore = hasEditIssueEstimDue || hasIssueEstimDue
															const duration = calculateDuration(newValue, formik.values.EstimDueDt, dateFormat, t, checkIfBefore);
															formik.setFieldValue('EstimDuration', duration);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'EstimStartDt'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_estimated_start : issue_estimated_start]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 5,
											lg: fromDashboard ? 12 : 5,
											xl: fromDashboard ? 6 : 5
										}}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['EstimStartTm'] &&
													Boolean(formik.errors['EstimStartTm'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_estimated_start : issue_estimated_start]}>
													<FormLabel>{t('Est. Start Time')}</FormLabel>
													<TimePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="EstimStartTm"
														format={timeFormat}
														ampm={false}
														value={formik.values.EstimStartTm}
														onChange={(newValue) => {
															formik.setFieldValue('EstimStartTm', newValue);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'EstimStartTm'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_estimated_end : issue_estimated_end]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 7,
											lg: fromDashboard ? 12 : 7,
											xl: fromDashboard ? 6 : 7
										}}
											  sx={{ display: 'flex', flexDirection: 'row' }}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['EstimDueDt'] &&
													Boolean(formik.errors['EstimDueDt'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_estimated_end : issue_estimated_end]}>
													<FormLabel>{t('Est. Expiry')}</FormLabel>
													<DatePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="EstimDueDt"
														views={['year', 'month', 'day']}
														format={dateFormat}
														value={formik.values.EstimDueDt}
														onChange={(newValue) => {
															formik.setFieldValue('EstimDueDt', newValue);
															const checkIfBefore = hasEditIssueEstimDue || hasIssueEstimDue
															const duration = calculateDuration(formik.values.EstimStartDt, newValue, dateFormat, t, checkIfBefore)
															formik.setFieldValue('EstimDuration', duration);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'EstimDueDt'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_estimated_end : issue_estimated_end]}>
										<Grid size={{
											xs: 12,
											sm: 12,
											md: fromDashboard ? 12 : 5,
											lg: fromDashboard ? 12 : 5,
											xl: fromDashboard ? 6 : 5
										}}
											  sx={{ display: 'flex', flexDirection: 'row' }}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['EstimDueTm'] &&
													Boolean(formik.errors['EstimDueTm'])
												}
											>
												<PermissionHOC
													requiredPermissions={[IssueId ? edit_issue_estimated_end : issue_estimated_end]}>
													<FormLabel>{t('Est. Expiry Time')}</FormLabel>
													<TimePicker
														slotProps={{
															textField: {
																size: 'small',
																variant: 'standard'
															}
														}}
														name="EstimDueTm"
														ampm={false}
														format={timeFormat}
														value={formik.values.EstimDueTm}
														onChange={(newValue) => {
															formik.setFieldValue('EstimDueTm', newValue);
														}}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'EstimDueTm'}/>
													</FormHelperText>
												</PermissionHOC>
											</FormControl>
										</Grid>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[IssueId ? edit_issue_duration : issue_duration]}>
										<Grid size={12}
											  sx={{ display: 'flex', justifyContent: 'space-between' }}>
											<Grid size={{ xs: 7 }}>
												<FormControl
													{...formControlDefaults}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_duration : issue_duration]}>
														<FormLabel>{t('Duration')}</FormLabel>
														<NumericFormat
															{...numericFormatDefaults}
															thousandSeparator={thousandSeparator}
															decimalSeparator={decimalSeparator}
															name={'EstimDuration'}
															value={formik.values.EstimDuration}
															onValueChange={(values, sourceInfo) => {
																formik.setFieldValue('EstimDuration', values.floatValue ? values.floatValue : '')
															}}
															onBlur={formik.handleBlur}
														/>
													</PermissionHOC>
												</FormControl>
											</Grid>
											<Grid size={{ xs: 5 }} display={'flex'} alignItems={'end'}>
												<FormControl
													{...formControlDefaults}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_duration : issue_duration]}>
														<TextField
															{...textFieldSelectDefaults}
															sx={{ top: '-2px' }}
															// sx={{maxWidth: '100px'}}
															onChange={(evt) => handleTimeUnits(evt, 'convertEstimDuration', 'EstimDuration')}
															onBlur={formik.handleBlur}
															value={formik.values.convertEstimDuration}
															name="convertEstimDuration"
														>
															{TimeUnits?.map((timeUnit) => (
																<MenuItem
																	dense
																	key={timeUnit?.id}
																	value={timeUnit?.id}
																>
																	{timeUnit.Description}
																</MenuItem>
															))}
														</TextField>
													</PermissionHOC>
												</FormControl>
											</Grid>
										</Grid>
									</PermissionHOC>
								</Grid>
							</Box>
						</Grid>
						<PermissionHOC
							requiredPermissions={[IssueId ? view_edit_financial_info : view_financial_info]}>
							<Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
								<Box>
									<Grid container spacing={2}>
										<Grid size={{ xs: 12 }}>
											<FormBoxTitle
												title={t('Financial Info')}
											/>
										</Grid>
										<PermissionHOC
											requiredPermissions={[IssueId ? edit_issue_estimated_work : issue_estimated_work]}>
											<Grid size={12}
												  sx={{ display: 'flex', justifyContent: 'space-between' }}>
												<Grid size={{ xs: 7 }}>
													<FormControl
														{...formControlDefaults}
													>
														<PermissionHOC
															requiredPermissions={[IssueId ? edit_issue_estimated_work : issue_estimated_work]}>
															<FormLabel>{t('Est. Work')}</FormLabel>
															<NumericFormat
																{...numericFormatDefaults}
																thousandSeparator={thousandSeparator}
																decimalSeparator={decimalSeparator}
																name={'EstimWork'}
																value={formik.values.EstimWork}
																onValueChange={(values, sourceInfo) => {
																	formik.setFieldValue('EstimWork', values.floatValue ? values.floatValue : '')
																}}
																onBlur={formik.handleBlur}
															/>
														</PermissionHOC>
													</FormControl>
												</Grid>
												<Grid size={{ xs: 5 }} display={'flex'} alignItems={'end'}>
													<FormControl
														{...formControlDefaults}
													>
														<PermissionHOC
															requiredPermissions={[IssueId ? edit_issue_estimated_work : issue_estimated_work]}>
															<TextField
																{...textFieldSelectDefaults}
																// sx={{maxWidth: '100px'}}
																onChange={(evt) => handleTimeUnits(evt, 'convertEstimWork', 'EstimWork')}
																onBlur={formik.handleBlur}
																value={formik.values.convertEstimWork}
																name="convertEstimWork"
															>
																{TimeUnits?.map((timeUnit) => (
																	<MenuItem
																		dense
																		key={timeUnit?.id}
																		value={timeUnit?.id}
																	>
																		{timeUnit.Description}
																	</MenuItem>
																))}
															</TextField>
														</PermissionHOC>
													</FormControl>
												</Grid>
											</Grid>
										</PermissionHOC>
										<PermissionHOC
											requiredPermissions={[IssueId ? edit_issue_estimated_cost : issue_estimated_cost]}>
											<Grid size={12}>
												<FormControl
													{...formControlDefaults}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_estimated_cost : issue_estimated_cost]}>
														<FormLabel>{t('Est. Cost')}</FormLabel>
														<NumericFormat
															{...numericFormatDefaults}
															thousandSeparator={thousandSeparator}
															decimalSeparator={decimalSeparator}
															name={'EstimCost'}
															value={formik.values.EstimCost}
															onValueChange={(values, sourceInfo) => {
																formik.setFieldValue('EstimCost', values.floatValue ? values.floatValue : '')
															}}
															onBlur={formik.handleBlur}
														/>
													</PermissionHOC>
												</FormControl>
											</Grid>
										</PermissionHOC>
										<PermissionHOC
											requiredPermissions={[IssueId ? edit_issue_proposed_work : issue_proposed_work]}>
											<Grid
												size={12}
												sx={{ display: 'flex', justifyContent: 'space-between' }}
											>
												<Grid size={{ xs: 7 }}>
													<FormControl
														{...formControlDefaults}
													>
														<PermissionHOC
															requiredPermissions={[IssueId ? edit_issue_proposed_work : issue_proposed_work]}>
															<FormLabel>{t('Proposed Work')}</FormLabel>
															<NumericFormat
																{...numericFormatDefaults}
																thousandSeparator={thousandSeparator}
																decimalSeparator={decimalSeparator}
																name={'ProposedWork'}
																value={formik.values.ProposedWork}
																onValueChange={(values, sourceInfo) => {
																	formik.setFieldValue('ProposedWork', values.floatValue ? values.floatValue : '')
																}}
																onBlur={formik.handleBlur}
															/>
														</PermissionHOC>
													</FormControl>
												</Grid>
												<Grid size={{ xs: 5 }} display={'flex'} alignItems={'end'}>
													<FormControl
														{...formControlDefaults}
													>
														<PermissionHOC
															requiredPermissions={[IssueId ? edit_issue_proposed_work : issue_proposed_work]}>
															<TextField
																{...textFieldSelectDefaults}
																onChange={(evt) => handleTimeUnits(evt, 'convertPropWork', 'ProposedWork')}
																onBlur={formik.handleBlur}
																value={formik.values.convertPropWork}
																name="convertPropWork"
															>
																{TimeUnits?.map((timeUnit) => (
																	<MenuItem
																		dense
																		key={timeUnit?.id}
																		value={timeUnit?.id}
																	>
																		{timeUnit.Description}
																	</MenuItem>
																))}
															</TextField>
														</PermissionHOC>
													</FormControl>
												</Grid>
											</Grid>
										</PermissionHOC>
										<PermissionHOC
											requiredPermissions={[IssueId ? edit_issue_charge : issue_charge]}>
											<Grid size={12}>
												<FormControl
													{...formControlDefaults}
													error={
														formik.touched['ChargeCost'] &&
														Boolean(formik.errors['ChargeCost'])
													}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_charge : issue_charge]}>
														<FormLabel>{t('Subcontractor Charge')}</FormLabel>
														<NumericFormat
															{...numericFormatDefaults}
															thousandSeparator={thousandSeparator}
															decimalSeparator={decimalSeparator}
															name={'ChargeCost'}
															value={formik.values.ChargeCost}
															onValueChange={(values, sourceInfo) => {
																formik.setFieldValue('ChargeCost', values.floatValue ? values.floatValue : '')
															}}
															onBlur={formik.handleBlur}
														/>
														<FormHelperText>
															<ErrorMessage name={`ChargeCost`}/>
														</FormHelperText>
													</PermissionHOC>
												</FormControl>
											</Grid>
										</PermissionHOC>
										<PermissionHOC
											requiredPermissions={[IssueId ? edit_issue_actual_charge : issue_actual_charge]}>
											<Grid size={12}>
												<FormControl
													{...formControlDefaults}
													error={
														formik.touched['ActualCost'] &&
														Boolean(formik.errors['ActualCost'])
													}
												>
													<PermissionHOC
														requiredPermissions={[IssueId ? edit_issue_actual_charge : issue_actual_charge]}>
														<FormLabel>{t('Customer Cost')}</FormLabel>
														<NumericFormat
															{...numericFormatDefaults}
															thousandSeparator={thousandSeparator}
															decimalSeparator={decimalSeparator}
															name={'ActualCost'}
															value={formik.values.ActualCost}
															onValueChange={(values, sourceInfo) => {
																formik.setFieldValue('ActualCost', values.floatValue ? values.floatValue : '')
															}}
															onBlur={formik.handleBlur}
														/>
														<FormHelperText>
															<ErrorMessage name={`ActualCost`}/>
														</FormHelperText>
													</PermissionHOC>
												</FormControl>
											</Grid>
										</PermissionHOC>
									</Grid>
								</Box>
							</Grid>
						</PermissionHOC>
						<PermissionHOC requiredPermissions={[IssueId ? edit_issue_view_items : issue_view_items]}>
							<Items
								formik={formik}
								theme={theme}
								IssueId={IssueId}
								initialItems={items}
								isBelowSm={isBelowSm}
							/>
						</PermissionHOC>
						<Assets formik={formik} initialAssets={assets} theme={theme}/>
						<Grid
							size={{ xs: 12, sm: 12, md: 12, lg: 6 }}
						>
							<FormBoxTitle
								title={t('Comments')}
								children={
									<Button
										onClick={handleAddNote}
										variant={'text'}
										startIcon={<AddIcon/>}
									>
										{t('Add')}
									</Button>
								}
							/>
							{formik.values.Notes?.map((note, noteIndex) => {
								return (
									<Box key={note?.id}>
										<Grid
											container
											spacing={1}
										>
											<Grid size={12} sx={{
												padding: 0.2,
												marginBottom: 0.8,
												borderLeft: `4px solid ${theme.palette.success.main}`
											}}>
												<Box sx={{
													display: 'flex',
													justifyContent: 'space-between',
													background: '#fff5ee',
													paddingLeft: 0.4,
													paddingRight: 0.4
												}}>
													<Typography
														component={'div'}
														variant={'body1'}
														sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
													>
														{note.LoginName}
													</Typography>
													<Typography
														component={'div'}
														variant={'body1'}
														sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
													>
														{note.LastModifiedAt}
													</Typography>
													{!note.isDisabled && (
														<IconButton
															size={'small'}
															color="error"
															onClick={() => handleRemoveNote(noteIndex)}
														>
															<ClearIcon/>
														</IconButton>
													)}
												</Box>
												<FormControl {...formControlDefaults}>
													<TextField
														{...textFieldDefaults}
														name={`Notes[${noteIndex}].Body`}
														value={note.Body}
														onChange={(e) => formik.setFieldValue(`Notes[${noteIndex}].Body`, e.target.value)}
														onBlur={formik.handleBlur}
														inputtype="textarea"
														multiline
														rows={3}
														disabled={note.isDisabled}
													/>
												</FormControl>
											</Grid>
										</Grid>
									</Box>
								)
							})}
						</Grid>
						<PermissionHOC
							requiredPermissions={[IssueId ? edit_issue_assignee : issue_assignee]}>
						<Grid
							size={{ xs: 12, sm: 12, md: 12, lg: 6 }}
						>
							<FormBoxTitle
								title={t('Internal Comments')}
								children={
									<Button
										onClick={handleAddInternalNote}
										variant={'text'}
										startIcon={<AddIcon/>}
									>
										{t('Add')}
									</Button>
								}
							/>
							{formik.values.InternalNotes?.map((note, noteIndex) => {
								return (
									<Box key={note?.id}>
										<Grid
											container
											spacing={1}
										>
											<Grid size={12} sx={{
												padding: 0.2,
												marginBottom: 0.8,
												borderLeft: `4px solid ${theme.palette.success.main}`
											}}>
												<Box sx={{
													display: 'flex',
													justifyContent: 'space-between',
													background: '#fff5ee',
													paddingLeft: 0.4,
													paddingRight: 0.4
												}}>
													<Typography
														component={'div'}
														variant={'body1'}
														sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
													>
														{note.LoginName}
													</Typography>
													<Typography
														component={'div'}
														variant={'body1'}
														sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
													>
														{note.LastModifiedAt}
													</Typography>
													{!note.isDisabled && (
														<IconButton
															size={'small'}
															color="error"
															onClick={() => handleRemoveInternalNote(noteIndex)}
														>
															<ClearIcon/>
														</IconButton>
													)}
												</Box>
												<FormControl {...formControlDefaults}>
													<TextField
														{...textFieldDefaults}
														name={`InternalNotes[${noteIndex}].Body`}
														value={note.Body}
														onChange={(e) => formik.setFieldValue(`InternalNotes[${noteIndex}].Body`, e.target.value)}
														onBlur={formik.handleBlur}
														inputtype="textarea"
														multiline
														rows={3}
														disabled={note.isDisabled}
													/>
												</FormControl>
											</Grid>
										</Grid>
									</Box>
								)
							})}
						</Grid>
						</PermissionHOC>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
							<FormBoxTitle title={t('Attachments')}/>
							<FileUpload
								files={formik.values.files}
								multiple={true}
								onRemove={onFileChange}
								onFilesUpload={onFileChange}
							/>
						</Grid>
						{IssueId && (
							<PermissionHOC
								requiredPermissions={[view_issue_auditing]}>
								<Grid size={12}>
									{IssueId && (
										<PermissionHOC
											requiredPermissions={[view_issue_auditing]}>
											<FormBoxTitle title={t('History')}/>
											<IssueAuditingHistory IssueId={IssueId}/>
										</PermissionHOC>
									)}
								</Grid>
							</PermissionHOC>
						)}
					</Grid>
				</PageContentWrapper>
				<Confirmation
					open={confirmation.open}
					handleDialog={onCloseConfirmation}
					onNo={onCloseConfirmation}
					onYes={() => {
						formik.handleSubmit()
					}}
					loading={loadingSubmit}
					title={t('Confirm you wish to continue with this action.')}
				>
					{(confirmation.status && confirmation.status === IssueStatus.Akurothike) && (
						<FormControl
							required {...formControlDefaults}
							error={
								formik.touched['CancelComment'] &&
								Boolean(formik.errors['CancelComment'])
							}
						>
							<FormLabel required>{t('Comment')}</FormLabel>
							<TextField
								{...textFieldDefaults}
								name={'CancelComment'}
								value={formik.values.CancelComment}
								placeholder={t('Write a comment...')}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
								inputtype="textarea"
								multiline
								rows={3}
							/>
							<FormHelperText>
								<ErrorMessage name={`CancelComment`}/>
							</FormHelperText>
						</FormControl>
					)}
					{/*TODO::Ενεργοποίησέ το πάλι όταν ζητήσουν να γίνει υποχρεωτική η συμπλήρωσή του! Είπαν στην πρώτη φάση να μην είναι. */}
					{/*{(confirmation.status && confirmation.status === IssueStatus.Epilithike && hasEditIssueActualStart && !formik.values.ActualStartDt) && (*/}
					{/*	<FormHelperText sx={{fontSize: 14}}>*/}
					{/*		{t('Actual Start Date is required to close this ticket!')}*/}
					{/*	</FormHelperText>*/}
					{/*)}*/}
				</Confirmation>
				{IssueId && (
					<Confirmation
						open={openSOForm}
						handleDialog={closeSOForm}
						yesAction={false}
						noAction={false}
						loading={loadingSubmit}
						title={t('Submit Customer Offer (SO)')}
						maxWidth={'xl'}
						otherDialogProps={{
							fullScreen: true
						}}
					>
						<CustomerSO
							issueId={IssueId}
							openForm={openSOForm}
							closeForm={closeSOForm}
							onEmailSendSuccess={() => {
								issueDataManager()
								if(fromDashboard) {
									onSuccess({formik})
								}
							}}
						/>
					</Confirmation>
				)}
			</Box>
		</FormikProvider>
	)
}

export default IssueForm